import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import Box from '@mui/material/Box';
import MainFeaturedPost from './MainFeaturedPost';
import { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';

// セクションのデータ
const sections = [
  { title: 'all', url: '/' },
  { title: 'life', url: '/category/life' },
  { title: 'programming', url: '/category/programming' },
  { title: 'money', url: '/category/money' },
  { title: 'gadget', url: '/category/gadget' },
  { title: 'sports', url: '/category/sports' },
  // { title: 'cooking', url: '/category/cooking' },
  { title: 'others', url: '/category/others' },
];

const mainFeaturedPost = {
  title: (
    <Typography
      variant="h5" // ここでサイズ調整
      component="h1"
      sx={{ fontWeight: 'bold', color: '#fff', mb: 0 }}
    >
      脱サラ後の戯言。。。
    </Typography>
  ),
  description: '',
  image: '/images/mainpost.png',
  imageText: 'メイン画像の説明',
};

// デフォルトのアーカイブデータ（API取得失敗時に表示）
const defaultArchives = [
];

// テーマ設定
const theme = createTheme({
  palette: {
    primary: { main: '#556cd6' },
    secondary: { main: '#19857b' },
    background: { default: '#f9f9f9' },
  },
  typography: {
    fontFamily: ['"Noto Sans JP"', 'sans-serif'].join(','),
  },
});

export default function Layout({ children, showSidebar = true }) {
  const [archives, setArchives] = useState(defaultArchives);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // APIから年月データを取得
    const fetchArchives = async () => {
      try {
        setLoading(true);
        
        // APIのベースURLを設定（環境に応じて変更）
        const apiBaseUrl = process.env.REACT_APP_API_URL || '';
        const response = await fetch(`${apiBaseUrl}/api/ym`);
        
        if (!response.ok) {
          throw new Error(`API error: ${response.status}`);
        }
        
        const data = await response.json();
        console.log('APIから取得したデータ:', data);
        
        // データが配列かどうか確認
        if (Array.isArray(data) && data.length > 0) {
          setArchives(data.map((ym) => ({
            title: `${ym.slice(0, 4)}年${parseInt(ym.slice(4, 6))}月`, // 表示用（例: "2025年4月"）
            url: `/archive/${ym}` // URL用（例: "/archive/202504"）
          })));
        } else {
          console.warn('APIからのデータが空配列または配列ではありません', data);
        }
      } catch (err) {
        console.error('Error fetching archives:', err);
        setError(err.message);
        // エラー時はデフォルトのアーカイブをそのまま使用
      } finally {
        setLoading(false);
      }
    };

    fetchArchives();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="lg">
        <Header title="雇われずに生きてみたら" sections={sections} />

        {/* MainFeaturedPost をページ全体の共通要素として配置 */} 
        <Box sx={{ width: '100%', mb: 4 }}>
          <MainFeaturedPost post={mainFeaturedPost} />
        </Box>

        {/* 記事エリアとサイドバーのレイアウト */}
        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 4,
          alignItems: 'flex-start' //'stretch'だと左75%と右25%の高さが同じになる
        }}>
          {/* ★ 記事エリア - サイドバーがある場合とない場合で幅を調整 */}
          <Box sx={{
            flex: showSidebar 
              ? { xs: '1 1 100%', md: '3 1 0' } // ★ サイドバーあり: 3:1の比率
              : '1 1 100%', // ★ サイドバーなし: 100%
            bgcolor: 'background.paper',
            p: 3,
            borderRadius: 1,
            minWidth: 0, // ★ flex shrinkを有効にする
            width: '100%' // 追加: 幅を100%に設定
          }}>
            {children}
          </Box>

          {/* ★ サイドバー - 1の比率 */}
          {showSidebar && (
            <Box sx={{
              flex: { xs: '1 1 100%', md: '1 1 0' }, // ★ 1の比率
              bgcolor: 'background.default',
              p: 3,
              borderRadius: 1,
              boxShadow: 1,
              minWidth: { md: '250px' }, // ★ 最小幅を設定
              maxWidth: { md: '300px' }, // ★ 最大幅を設定
            }}>
              <Sidebar
                title='About'
                description={`ギリギリ昭和生まれ。\n正社員を辞めて独学でフリーランスエンジニアとなり、マイクロ法人を持ちつつ活動しています。日々抱える葛藤等を気ままに発信します。`}
                archives={archives}
                loading={loading}
                error={error}
              />
            </Box>
          )}
        </Box>

        {/* フッターの直前に区切りを追加 */}
        <Box sx={{
          width: '100%',
          height: '20px',
          mb: 4,
        }} />

      </Container>
      <Footer />
    </ThemeProvider>
  );
}